export const ALL_BLOG = "ALL_BLOG";
export const SEL_BLOG = "SEL_BLOG";
export const ALL_BLOG_COUNT = "ALL_BLOG_COUNT";
export const SEL_BLOG_COMMENTS = "SEL_BLOG_COMMENTS";
export const SEL_BLOG_COMMENTS_COUNT = "SEL_BLOG_COMMENTS_COUNT";
